const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

class APIService {
  // Sessions
  async createSession(chatName, userLocation) {
    const response = await fetch(`${API_URL}/api/firestore/sessions`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ chatName, userLocation })
    });
    return response.json();
  }

  async saveTurn(sessionId, turnData) {
    const response = await fetch(`${API_URL}/api/firestore/sessions/${sessionId}/turns`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(turnData)
    });
    return response.json();
  }

  async updateAssistantMessage(sessionId, turnId, assistantMessage) {
    const response = await fetch(
      `${API_URL}/api/firestore/sessions/${sessionId}/turns/${turnId}/assistant`,
      {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ assistantMessage })
      }
    );
    return response.json();
  }

  async updateSuggestions(sessionId, turnId, suggestions) {
    const response = await fetch(
      `${API_URL}/api/firestore/sessions/${sessionId}/turns/${turnId}/suggestions`,
      {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ suggestions })
      }
    );
    return response.json();
  }

  async saveReport(sessionId, turnId, reportData) {
    const response = await fetch(
      `${API_URL}/api/firestore/sessions/${sessionId}/turns/${turnId}/reports`,
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(reportData)
      }
    );
    return response.json();
  }

  async updateChatName(sessionId, chatName) {
    const response = await fetch(
      `${API_URL}/api/firestore/sessions/${sessionId}/name`,
      {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ chatName })
      }
    );
    return response.json();
  }

  async closeSession(sessionId) {
    const response = await fetch(
      `${API_URL}/api/firestore/sessions/${sessionId}/close`,
      { method: 'PATCH' }
    );
    return response.json();
  }

  async saveFeedback(sessionId, turnId, feedbackData) {
    const response = await fetch(
      `${API_URL}/api/firestore/sessions/${sessionId}/turns/${turnId}/feedback`,
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(feedbackData)
      }
    );
    return response.json();
  }

  async removeFeedback(sessionId, turnId) {
    const response = await fetch(
      `${API_URL}/api/firestore/sessions/${sessionId}/turns/${turnId}/feedback`,
      { method: 'DELETE' }
    );
    return response.json();
  }

  // Suggestions Feedback
  async saveSuggestionsFeedback(sessionId, turnId, feedbackData) {
    const response = await fetch(
      `${API_URL}/api/firestore/sessions/${sessionId}/turns/${turnId}/suggestions/feedback`,
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(feedbackData)
      }
    );
    return response.json();
  }

  async removeSuggestionsFeedback(sessionId, turnId) {
    const response = await fetch(
      `${API_URL}/api/firestore/sessions/${sessionId}/turns/${turnId}/suggestions/feedback`,
      { method: 'DELETE' }
    );
    return response.json();
  }

  // Report Feedback
  async saveReportFeedback(sessionId, turnId, reportId, feedbackData) {
    const response = await fetch(
      `${API_URL}/api/firestore/sessions/${sessionId}/turns/${turnId}/reports/${reportId}/feedback`,
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(feedbackData)
      }
    );
    return response.json();
  }

  async removeReportFeedback(sessionId, turnId, reportId) {
    const response = await fetch(
      `${API_URL}/api/firestore/sessions/${sessionId}/turns/${turnId}/reports/${reportId}/feedback`,
      { method: 'DELETE' }
    );
    return response.json();
  }

  // File upload
  async uploadFile(sessionId, turnNumber, file) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('sessionId', sessionId);
    formData.append('turnNumber', turnNumber);
    formData.append('originalFilename', file.name);

    const response = await fetch(`${API_URL}/files/upload`, {
      method: 'POST',
      body: formData
    });
    return response.json();
  }
}

export default new APIService();
